<template>
    <!--========== FOOTER ==========-->
    <footer class="bg-foot g-bg-color--dark-light">
        <!-- Copyright -->
        <div class="container g-padding-y-50--xs">
            <div class="row hidden">
                <div class="col-md-12">
                    <div class="address">
                        <p><span class="fa fa-mobile ic-phone"></span> (11) 4506-3119
                            <br />
                            <a href="mailto:sacmundialinfo@gmail.com">sacmundialinfo@gmail.com</a></p>
                        <p class="social">

                            <a href="#"> <i class=" fa fa-facebook"></i></a>
                            <a href="#"> <i class="fa fa-instagram"></i> </a>

                        </p>
                    </div>
                </div>

            </div>
        </div>
        <!-- End Copyright -->

        <div class="copy-area">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 col-md-offset-2">
                        <p class="text-center">Os anúncios publicitários aqui são de responsabilidade exclusiva de seus respectivos anunciantes, bem como o conteúdo editorial dos anuncios. Declinamos toda e qualquer responsabilidade legal advinda dos anuncios acessadas através da Guia Divulga Mais Brasil, o qual tem por objetivo apenas a divulgação.</p>
                        <p class="text-center"><strong>Guia Divulga Mais Brasil</strong> ® - Todos os direitos reservados © {{year}}</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!--========== END FOOTER ==========-->
</template>

<script>
export default {
  name: 'FooterView',
  data: function () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/layout/Footer.vue